import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import { Link } from "react-router-dom";
import { PrimaryButton } from "Components/Button";
import { asset } from "Services/BaseHelpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";

export default class Dashboard extends React.Component {
    render () {
        return (
            <Authenticated
                title="Dashboard"
            >
                <div className="p-4 space-y-10 w-full h-full">
                    <img
                        className="mx-auto m-4 relative lg:absolute lg:right-14"
                        src={asset('images/hazard/ee-logo.png')}
                    />

                    <div className="text-white text-center w-3/4 mx-auto">
                        <h1 className="text-2xl font-bold mb-4">
                            TIME TO WIN with EE Cyber Security, powered by Norton™
                        </h1>

                        <p>
                            Help keep your devices and identity protected with our{" "}
                            <a
                                href="https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwebaem-phoenix-stage.ps.intdigital.ee.co.uk%2Fsecurity%2Fcyber-security&data=05%7C01%7Calexandra.2.crouch%40ee.co.uk%7Ccb9f00b5cb8e48c9ab4f08dad4854dda%7Ca7f356889c004d5eba4129f146377ab0%7C0%7C0%7C638055966236407971%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=aBKmuRm%2BeY8tRoLRJC8OoXEUQH%2Fd6dG9S6sZEROPe1M%3D&reserved=0"
                                target="_blank"
                                className="underline"
                            >
                                new EE Cyber Security
                            </a>. 
                            It's our advanced online security service working in partnership with Norton™. 
                            It's super easy. You can add EE Cyber Security to your EE mobile plan from just £2 per month, 
                            and it comes with a range of features to help keep you protected on up to 15 devices.
                        </p>

                        <p>
                            To win some prizes from Norton™ simply{" "}
                            <a
                                href="https://eur02.safelinks.protection.outlook.com/?url=https%3A%2F%2Fcyberhomeactivation.co.uk%2Fsite-login&data=05%7C01%7Calexandra.2.crouch%40ee.co.uk%7Ccb9f00b5cb8e48c9ab4f08dad4854dda%7Ca7f356889c004d5eba4129f146377ab0%7C0%7C0%7C638055966236407971%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&sdata=z5basizYk35gIJXuZvP17S8XSU%2FeRCjnzk7WU2VA8so%3D&reserved=0"
                                target="_blank"
                                className="underline"
                            >
                                play our cyber security game online
                            </a>
                            {" "}between 7 December 2022 and 2 January 2023 to be included in the prize draw.
                        </p>

                        <p>
                            Prizes: 1 x Bose speaker, 5 Mophie Powerstations, 10 x headphones, 25 x wireless chargers
                        </p>
                    </div>

                    <div className="h-80 flex justify-center">
                        <iframe
                            src="https://player.vimeo.com/video/768042355?h=90ce963226"
                            className={"w-full h-full"}
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                        />
                    </div>

                    <div className="flex flex-col md:flex-row justify-center full-width gap-8 p-4">
                        <div className="w-full md:w-1/2 border-app-yellow border-dotted border-4 rounded-lg">
                            <Link
                                to='/hazard-perception-game'
                                className="m-5"
                            >
                                <img
                                    className="mx-auto m-4"
                                    src={asset('images/microsite/verisure-logo.png')}
                                />

                                <img
                                    className="mx-auto m-4"
                                    src={asset('images/microsite/hazard.png')}
                                />
                            </Link>
                        </div>

                        <div className="w-full md:w-1/2 border-app-yellow border-dotted border-4 rounded-lg">
                            <Link
                                to='/pac-man-game'
                                className="m-5"
                            >
                                <img
                                    className="mx-auto m-4"
                                    src={asset('images/microsite/norton-logo.png')}
                                />

                                <img
                                    className="mx-auto m-4"
                                    src={asset('images/microsite/pac-man.png')}
                                />
                            </Link>
                        </div>
                    </div>
                </div>
            </Authenticated>
        );
    }
}
